import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Empty, Skeleton } from "antd";
import { publicApi } from "../services/api";
import { SEOHead } from "../components/SEOHead";
import { WorkCard, SectionHeading, QueryError } from "../components/Editorial";
import { StatsSummary, YearChart } from "../components/LibraryStats";
import { periodLabel } from "../utils/period";

export function DashboardPage() {
  const navigate = useNavigate();
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const latest = useQuery({
    queryKey: ["public-library-latest", 8],
    queryFn: () => publicApi.listLibrary({ page: 1, page_size: 8 }),
  });
  return (
    <div className="home-page">
      <SEOHead
        title="Biblioteka książek, filmów i seriali"
        description="Osobisty dziennik kultury. Przeczytane książki, obejrzane filmy i seriale, własne oceny i historie zapisane w statystykach."
        canonicalPath="/"
      />
      <section className="recent-section">
        <SectionHeading
          eyebrow="Ostatnie strony i napisy końcowe"
          title="Ostatnio ukończone"
          headingLevel={1}
          action={
            <Link className="text-link" to="/library">
              Cała biblioteka ↗
            </Link>
          }
        />
        {latest.isError ? (
          <QueryError retry={() => void latest.refetch()} />
        ) : latest.isPending ? (
          <Skeleton active paragraph={{ rows: 5 }} />
        ) : latest.data.items.length ? (
          <div className="work-grid recent-grid">
            {latest.data.items.map((entry) => (
              <WorkCard key={entry.id} entry={entry} />
            ))}
          </div>
        ) : (
          <Empty description="Pierwsze historie dopiero przed nami." />
        )}
      </section>
      <section className="home-month">
        <SectionHeading
          eyebrow="Ten miesiąc"
          title={periodLabel(year, month)}
          action={
            <Link
              className="text-link"
              to={`/stats?year=${year}&month=${month}`}
            >
              Zobacz tytuły i statystyki ↗
            </Link>
          }
        />
        <StatsSummary year={year} month={month} />
      </section>
      <YearChart
        year={year}
        onMonth={(value) => navigate(`/stats?year=${year}&month=${value}`)}
      />
    </div>
  );
}
